import styled from 'styled-components';

const Wrapper = styled.section`
  min-height: 100vh;
  background-image: url(https://res.cloudinary.com/dlhfcdscf/image/upload/v1785140631/public/background_jsvis3.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  nav {
    width: var(--fluid-width);
    max-width: var(--max-width);
    margin: 0 auto;
    height: var(--nav-height);
    display: flex;
    align-items: center;
  }

  .page {
    min-height: calc(100vh - var(--nav-height));
    display: grid;
    align-items: center;
    margin-top: -1rem;
    direction: rtl;
  }

  h1 {
    font-weight: 700;
    font-size: 2.8rem;
    color: #ffffff;
    margin-bottom: 1.5rem;
    span {
      color: #00e5ff;
      text-shadow: 0 0 12px #00e5ff, 0 0 28px rgba(0, 229, 255, 0.6);
    }
  }

  p {
    line-height: 2;
    color: rgba(255, 255, 255, 0.82);
    margin-bottom: 1.5rem;
    max-width: 35em;
  }

  .btn {
    padding: 0.75rem 1.2rem;
    font-weight: 600;
    font-size: 1rem;
    letter-spacing: 0.03em;
    border-radius: 8px;
    cursor: pointer;
    text-decoration: none;
    display: inline-block;
    transition: box-shadow 0.25s ease, background 0.25s ease;
  }

  .register-link {
    margin-left: 1rem;
    background: transparent;
    border: 2px solid #00e5ff;
    color: #00e5ff;
    box-shadow: 0 0 8px #00e5ff, 0 0 20px rgba(0, 229, 255, 0.35);
    text-shadow: 0 0 8px rgba(0, 229, 255, 0.7);
    &:hover {
      background: rgba(0, 229, 255, 0.12);
      box-shadow: 0 0 14px #00e5ff, 0 0 36px rgba(0, 229, 255, 0.55);
    }
  }

  .btn:not(.register-link) {
    background: rgba(10, 15, 30, 0.55);
    border: 2px solid rgba(255, 255, 255, 0.35);
    color: #ffffff;
    box-shadow: 0 0 8px rgba(255, 255, 255, 0.12);
    &:hover {
      background: rgba(255, 255, 255, 0.1);
      box-shadow: 0 0 14px rgba(255, 255, 255, 0.28);
    }
  }

  .connect-btn-container {
    display: none;
    align-items: center;
    gap: 16px;
    padding: 1rem 1.2rem;
    border-radius: 8px;
    font-weight: 600;
    font-size: 1rem;
    text-decoration: none;
    background: transparent;
    border: 2px solid #ff1744;
    color: #ff1744;
    box-shadow: 0 0 8px #ff1744, 0 0 20px rgba(255, 23, 68, 0.35);
    text-shadow: 0 0 8px rgba(255, 23, 68, 0.7);
    margin-right: 8.5rem;
    margin-left: 1rem;
    margin-top: 1rem;
    transition: box-shadow 0.25s ease, background 0.25s ease;
    &:hover {
      background: rgba(255, 23, 68, 0.12);
      box-shadow: 0 0 14px #ff1744, 0 0 36px rgba(255, 23, 68, 0.55);
    }
  }

  .main-img {
    display: none;
  }

  @media (min-width: 1000px) {
    .page {
      grid-template-columns: 1fr 400px;
      column-gap: 3rem;
    }
    .main-img {
      display: block;
    }
    .connect-btn-container {
      display: inline-flex;
    }
  }
`;

export default Wrapper;
